import React from "react";
import { List } from "../modules/DiscrepancyManagement/";

export function DiscrepancyListPage() {
  return <List />;
}
